import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { queryAllDocsByField } from "../../Firebase/Firebase.utils";
import { useNavigate } from "react-router-dom";
import TimelineIcon from "@mui/icons-material/Timeline";
import { PieChartV1 } from "../../components/ui/PieChart";

export default function ISAccountCountCard({ setData }) {
  const currentUser = useSelector((state) => state.userObject);
  const navigate = useNavigate();
  const [accounts, setAccounts] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    const getLeasingAccounts = async () => {
      const data = await queryAllDocsByField(
        "listings",
        "team_members",
        "array-contains",
        currentUser.email,
        (data) => {
          setAccounts(data);
          setIsLoading(false);
        }
      );
    };
    getLeasingAccounts();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const potentialFee = accounts.reduce((acc, curr) => {
    const fee = parseFloat(curr.potential_fee);
    return acc + (isNaN(fee) ? 0 : fee);
  }, 0);

  const handleNavigate = () => {
    navigate("/all-listings");
  };

  return (
    <div
      className="bg-white w-48 h-24  p-2 rounded-lg shadow-md cursor-pointer"
      onClick={handleNavigate}
    >
      <div>
        <div className="flex items-center gap-4 mb-2">
          <div>
            <TimelineIcon className="text-leechiuBlue" />
          </div>
          <div className="text-xs text-gray-400">Potential Fees</div>
        </div>
        <span>Php </span>
        <span className="text-2xl font-bold text-leechiuBlue">
          {(potentialFee / 1000000).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          M
        </span>
      </div>
      <div className="text-leechiuOrange text-xs font-bold">
        {accounts.length} Accounts
      </div>
    </div>
  );
}
